<div class="container-fluid">
	<h2>{{'noc_config.recipients' | translate}}</h2>

	<!-- Action Buttons -->
	<div class="button-container mb-3">
		<button type="button" (click)="openAddDialog()" class="btn btn-primary mr-2">
			<i class="fa fa-plus mr-1"></i>
			{{'noc_config.add_new_email' | translate}}
		</button>
		<button type="button" (click)="goBack()" class="btn btn-secondary">
			<i class="fa fa-arrow-left mr-1"></i>
			{{'g.back' | translate}}
		</button>
	</div>

	<!-- Recipients Table -->
	<div class="mt-2 mb-2">
		<sct-custom-table
			*ngIf="tableData.length > 0"
			[data]="tableData"
			[columnsConfig]="columnConfig"
			[config]="tableConfig">
		</sct-custom-table>

		<div *ngIf="tableData.length === 0" class="alert alert-info">
			{{'g.no_data_available_for_the_selected_period' | translate}}
		</div>
	</div>

</div>

<!-- Add Email Modal -->
<app-modal #addEmailModal [title]="'noc_config.add_new_email' | translate" [closeBtnText]="'g.cancel' | translate">
	<div class="form-group">
		<label for="emailInput">
			{{'g.email' | translate}} <span class="text-danger">*</span>
		</label>
		<input
			type="email"
			class="form-control"
			id="emailInput"
			[(ngModel)]="newEmail"
			placeholder="example@domain.com"
			maxlength="255"
		/>
		<small class="form-text text-muted">
			{{'g.enter_valid_email' | translate}}
		</small>
	</div>
</app-modal>

<!-- Delete Confirmation Modal -->
<app-modal 
	#deleteRecipientModal 
	[title]="'g.confirm_action' | translate"
	[message]="'g.confirm_delete_message' | translate">
</app-modal>
